var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcaeBelt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.76,38.81H12.24c-2.08,0-3.77,1.69-3.77,3.78h0c0,2.09,1.69,3.78,3.77,3.78h27.07l-15.47,15.47c-1.48,1.48-1.48,3.87,0,5.34,1.48,1.48,3.87,1.48,5.34,0l20.82-20.82,25.69,25.69c1.48,1.48,3.87,1.48,5.34,0,1.47-1.48,1.47-3.87,0-5.34l-20.34-20.34h27.07c2.08,0,3.77-1.69,3.77-3.78,0-2.09-1.69-3.78-3.77-3.78Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcaeBelt);
export default __webpack_public_path__ + "static/media/acae_belt.ff75f972.svg";
export { ForwardRef as ReactComponent };